import reducer from "./reducer";
export { default as AssetsDiscountsEntryPerSociety } from "./components/index";
export { default as assetsDiscountsEntryPerSocietyReducerName } from "./constants";
export default reducer;
